import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
const ResumenInformacionEmpresa = ({ empresa }) => {
  const componentes = useSelector(
    (state) =>
      state.empresa &&
      state.empresa.empresaData &&
      state.empresa.empresaData.componentes
  );
  const empresaId = useSelector(
    (state) =>
      state.empresa &&
      state.empresa.empresaData &&
      state.empresa.empresaData.empresa_id
  );
  const { categoriasData } = useSelector((state) => state.categorias);

  return (
    <ContenedorInformacionEmpresa>
      {empresa && (
        <>
          <a href={empresa.sitio_web}>
            <img
              className="logo-empresa-footer"
              src={empresa.logo}
              alt={empresa.nombre}
              title={empresa.nombre}
            />
          </a>
          {empresaId === 1 && <strong>{empresa.eslogan}</strong>}
          <FootWelcome>{empresa.descripcion_corta}</FootWelcome>

          {componentes && componentes.FOOTER_LISTADO_CATEGORIAS && (
            <nav>
              <CategoriasEnFooter>
                {categoriasData &&
                  categoriasData.map((categoria, index) => (
                    <li key={index}>
                      <a href={categoria.urlseo}>{categoria.nombre}</a>
                    </li>
                  ))}
                <li>
                  <a href="landing/dermocosmetica">Dermocosmética</a>
                </li>
                <li>
                  <a href="landing/marcas-premium">Marcas Premium</a>
                </li>
                <li>
                  <a href="landing/cabellos-pro">Cabello Pro</a>
                </li>
              </CategoriasEnFooter>
            </nav>
          )}

          {empresaId === 4 && (
            <div>
              <b>Soriano 800 - Montevideo - Uruguay</b>
            </div>
          )}
          {componentes?.FOOTER_BANDERAS_PAISES && (
            <BanderasPaises>
              <li>
                <TituloPaises>LOi en otros países:</TituloPaises>
              </li>
              {empresa &&
                empresa.otrosPaises &&
                empresa.otrosPaises.map((paises, index) => (
                  <li key={index}>
                    <a href={paises.url} title={paises.nombre} target="_blank">
                      <img src={paises.img} alt={paises.nombre} />
                    </a>
                  </li>
                ))}
            </BanderasPaises>
          )}
        {empresa.pais_id === 1 && (
            <div>
              Bantey S.A. RUT: 215463840012
            </div>
          )}
          {empresa.pais_id === 1 && (
            <>
              {empresaId === 1 ? (
                <>
                  <FacturaBox
                    href="http://banteysa.dyndns.org:8585/consultaweb/"
                    target="_blank"
                  >
                    Consultá aquí tu factura electrónica, hasta el 30/9/20
                  </FacturaBox>

                  <FacturaBox
                    href="https://consulta.taface.com.uy/consulta.aspx?loi"
                    target="_blank"
                  >
                    Consultá aquí tu factura electrónica, desde el 01/10/20
                  </FacturaBox>
                  <hr />
                </>
              ) : (
                <div>
                  <a
                    href="https://consulta.taface.com.uy/consulta.aspx?loi"
                    target="_blank"
                  >
                    Consultá aquí tu factura electrónica
                  </a>
                </div>
              )}

            </>
          )}

        <a href="politicas">Políticas de garantía</a>
        <a href="terminos">Términos y Condiciones</a>
        </>
      )}
    </ContenedorInformacionEmpresa>
  );
};

const CategoriasEnFooter = styled.ul`
  display: flex;
  margin: 30px 0;
  > li {
    padding: 0px 10px;
    border-right: thin solid #eee;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: 0;
    }
  }
`;
const ContenedorInformacionEmpresa = styled.article`
  text-align: ${(props) => props.theme.footerInformationTextAlign};
  color: ${(props) => props.theme.footerColorTextos};
  a {
    text-decoration: none;
    color: ${(props) => props.theme.footerColorTextos};
    display: block;
    font-size: 14px;
    &:hover {
      text-decoration: underline;
    }
  }
  > a > img.logo-empresa-footer {
    width: 100%;
    max-width: 200px;
    margin-bottom: 20px;
    @media only screen and (max-width: 719px) {
      width: 50%;
    }
  }
`;
const FootWelcome = styled.h2`
  color: ${(props) => props.theme.footerColorTextos};
  font-weight: normal;
  font-size: 14px;
`;
const BanderasPaises = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 10px 0;
  width: 100%;
  text-align: center;
  > li {
    display: inline-block;
    margin: 5px;
    padding: 0;
    > img {
      width: 24px;
    }
  }
`;

const TituloPaises = styled.span`
  height: 24px;
  line-height: 24px;
  vertical-align: super;
  font-size: 16px;
  font-weight: bold;
`;

const FacturaBox = styled.a`
  width: 92%;
  padding: 2%;
  margin: 2%;
  overflow: hidden;
  display: block;
  border: 1px solid ${(props) => props.theme.primario};
  color: ${(props) => props.theme.footerColorTextos};
  border-radius: 5px;
  overflow: hidden;
  text-decoration: none;
  font-size: 12px;
  &:hover {
    color: white;
    background-color: ${(props) => props.theme.primario};
  }
  svg {
    margin-right: 10px;
  }
`;

export default ResumenInformacionEmpresa;
